import { Drawer, Menu, Switch, Button, Dropdown, Input } from "antd"
import { useTranslation } from "react-i18next"
import { useState, useEffect, useRef } from "react"
import { fetchCardSettings, writeCardSettings } from "../../api/Cards"
import { useUser } from "../../contexts/UserContext"
import { ArrowLeftOutlined } from "@ant-design/icons"
import FilterSettingsModal from "./Modals/filtersettings"

const CardSettingsDrawer = ({ drawerVisible, setDrawerVisible, card }) => {
    const onCloseDrawer = () => setDrawerVisible(false)
    const { t } = useTranslation()
    const { getToken, isAdmin, remoteProps, setRemoteProps } = useUser()
    //groupId must be unique within the current super-group

    //display settings entries
    const rotateDisplay = { type: 1, textId: "rotate", data: "bScreenRotation" }
    const screensaver = { type: 1, textId: "scrsvr", data: "bScreensaver" }
    const displaySettingsGroup = { type: 0, textId: "displaysettings", items: [rotateDisplay, screensaver] }
    //const [remoteProperties, setRemoteProperties] = useState(null)
    const [FilterSettings, setFilterSettings] = useState(false)

    const hideFilterSettings = () => setFilterSettings(false)
    const showFilterSettings = () => setFilterSettings(true)

    const languageConst = ["Svenska", "English"]
    const languageItems = [
        {
            key: 0,
            label: languageConst[0]
        },
        {
            key: 1,
            label: languageConst[1]
        }
    ]

    const languageSelection = {
        type: 2, textId: "language", data: "SelectedLanguage", items: languageItems, getCurrentSelection: (remoteProps) => { return languageConst[remoteProps.SelectedLanguage] }, onChange: (key, remoteProps) => { remoteProps.SelectedLanguage = parseInt(key); } }


    const brineConst = ["Brine Up", "Brine Down"]
    const brineItems = [
        {
            key: 0,
            label: brineConst[0]
        },
        {
            key: 1,
            label: brineConst[1]
        }
    ]
    const brineSelection = {
        type: 2, textId: "brine", data: "Brine", items: brineItems, getCurrentSelection: (remoteProps) => { return brineConst[remoteProps.Brine] }, onChange: (key, remoteProps) => { remoteProps.Brine = parseInt(key); }
    }


    const DPSwitch = { type: 1, textId: "dpswitch", data: "bDPSwitchEnabled" }
    const MAV = { type: 1, textId: "mav", data: "bMAVEnabled" }
    const Salt = { type: 1, textId: "salt", data: "bSaltEnabled" }
    const hardwareSettings = { type: 0, textId: "hardwaresettings", items: [DPSwitch, MAV, Salt] }

    const filterConfig = {
        type: 3, textId: "filter", onClick: () => { showFilterSettings(); onCloseDrawer() }
    }

    const useVolumeControl = { type: 1, textId: "volumecontrol", data: "bVolumeControl" }

    

    const valveSizes = ["1\"", "1.5\"", "2\""]
    const valveSizeItems = [
        {
            key: 0,
            label: valveSizes[0]
        },
        {
            key: 1,
            label: valveSizes[1]
        },
        {
            key: 2,
            label: valveSizes[2]
        }
    ]
    const valveSizeSelection = {
        type: 2, textId: "valvesize", data: "ValveSize", items: valveSizeItems, getCurrentSelection: (remoteProps) => { return valveSizes[remoteProps.ValveSize] }, onChange: (key, remoteProps) => { remoteProps.ValveSize = parseInt(key); }
    }

    const FlowSources = ["FLOW_OUT", "FLOW_IN"]

    const FlowSourceItems = [
        {
            key: 0,
            label: "FLOW_OUT"
        },
        {
            key: 1,
            label: "FLOW_IN"
        }
    ]

    const flowSourceSelection = {
        type: 2, textId: "flowsource", data: "FlowSourceIndex", items: FlowSourceItems, getCurrentSelection: (remoteProps) => { return FlowSources[remoteProps.FlowSourceIndex] }, onChange: (key, remoteProps) => { remoteProps.FlowSourceIndex = parseInt(key); }
    }

    const volumeControl = { type: 0, textId: "volumecontrol", items: [filterConfig, useVolumeControl, flowSourceSelection] }

    const basicSettings = { type: 0, textId: "basicsettings", items: [languageSelection, brineSelection, valveSizeSelection, volumeControl, hardwareSettings] }

    const networkTime = { type: 1, textId: "networktime", data: "bDateTimeNetwork" }
    const dateTimeSettings = { type: 0, textId: "dtime", items: [networkTime] }

    //Identification

    const cardName = { type: 4, textId: "cardname", data: "DeviceName" }
    const modelName = { type: 4, textId: "modelname", data: "ModelName" }
    const identificationSettings = { type: 0, textId: "identificationSettings", items: [cardName] }

    //0 : display group with sub-categories, 1: onclick action
    const mainDisplayGroup = { type: 0, textId: "main", items: [displaySettingsGroup, dateTimeSettings, basicSettings, identificationSettings] }

    const [currentDisplayGroup, setCurrentDisplayGroup] = useState(mainDisplayGroup)
    var prevDisplayGroup = useRef([]);


    
    
    useEffect(() => {

        async function loadSettings() {
            const data = await fetchCardSettings({ token: getToken(), cardIndex: card.cardIndex, cardID: card.id })
            if (typeof data == "number") {

                return
            }
            console.log("Data: ", data)
            //setRemoteProperties(data)
            setRemoteProps(data)
        }
        
        loadSettings()
    },[drawerVisible])

    function saveSettings() {
        if (!remoteProps)
            return

        console.log({ metaData: { token: getToken(), cardIndex: card.cardIndex, cardID: card.id }, propertyTable: remoteProps })
        writeCardSettings({ metaData: { token: getToken(), cardIndex: card.cardIndex, cardID: card.id }, propertyTable: remoteProps })
    }

    const closeAndSave = () => {
        saveSettings();
        hideFilterSettings();
    }


    function navigateBack() {
        saveSettings();
        setCurrentDisplayGroup(prevDisplayGroup.current.pop())
    }

    function renderReturnButton() {
        if (currentDisplayGroup.textId !== "main")
            return (<Menu.Item onClick={navigateBack} key="return" ><Button type="primary" shape="" ghost={true} icon={<ArrowLeftOutlined />} size="medium" /></Menu.Item>)

    }
    function renderDisplayGroup(displayGroup) {

        //setMainTitle()


        return currentDisplayGroup.items.map(item => renderItem(item, displayGroup))
    }

    function renderItem(item, parent) {
        switch (item.type) {
            case 0:
                return (<Menu.Item onClick={() => { prevDisplayGroup.current.push(currentDisplayGroup); setCurrentDisplayGroup(item) }} key={item.textId}>{t("page.card-details.settings.group." + item.textId)}</Menu.Item>) 
            case 1:
                return (<Menu.Item key={item.textId}>{t("page.card-details.settings.group." + item.textId)} <Switch onChange={(checked, event) => { remoteProps[item.data] = checked; }} checked={remoteProps[item.data]} style={{ float: "right", marginTop: "8px" }}></Switch></Menu.Item>) 
            case 2:
                return (<Menu.Item key={item.textId}><>{t("page.card-details.settings.group." + item.textId)} <Dropdown trigger={['click']} menu={{ items: item.items, onClick: (e) => { item.onChange(e.key, remoteProps); } }} placement="bottom"><Button style={{ float: "right", marginTop: "4px" }}>{item.getCurrentSelection(remoteProps)}</Button></Dropdown></></Menu.Item>) 
            case 3:
                return (<Menu.Item onClick={() => { item.onClick() }} key={item.textId}>{t("page.card-details.settings.group." + item.textId)}</Menu.Item>)
            case 4:
                return (<Menu.Item key={item.textId}><div>{t("page.card-details.settings.group." + item.textId)}: <Input style={{ width: "65%" }} onChange={(e) => { remoteProps[item.data] = e.target.value; }} defaultValue={remoteProps[item.data]}></Input></div></Menu.Item>)
        }

    }

    return ( 
        <>
            <Drawer
                title={t("page.card-details.settings.group." + currentDisplayGroup.textId)}
                placement="right"
                closable={true}
                onClose={onCloseDrawer}
                open={drawerVisible}
                style={{ position: "absolute" }}
                autoFocus={true}
            >
                <Menu mode="inline">
                    {renderReturnButton()}
                    {renderDisplayGroup(currentDisplayGroup)}
                </Menu>
            </Drawer>
            {FilterSettings && <FilterSettingsModal onClose={closeAndSave} remoteProperties={remoteProps} />}
        </>
    )
}
export default CardSettingsDrawer
